import Nullstack from 'nullstack';
export default function IconIdBadgeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-id-badge-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M7.141 3.125a3 3 0 0 1 .859 -.125h8a3 3 0 0 1 3 3v9m-.13 3.874a3.001 3.001 0 0 1 -2.87 2.126h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 .128 -.869"
  }), "   ", Nullstack.element("path", {
    d: "M11.179 11.176a2 2 0 1 0 2.635 2.667"
  }), "   ", Nullstack.element("path", {
    d: "M10 6h4"
  }), "   ", Nullstack.element("path", {
    d: "M9 18h6"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}